import request from 'api/request';

export default function readEmailRoute(address) {
  return request({
    url: '/emails/lookup',
    method: 'POST',
    data: { email: address },
  });
}
